import { EntityStatusBadge } from '@frontend/components/badge';
import { OrderStatus, OrderStatusName } from '@frontend/order/types';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

const ORDER_STATUS_MESSAGE_IDS: Record<OrderStatusName, { id: string; defaultMessage: string; description: string }> = {
    [OrderStatusName.ANY]: { id: 'Objects.ORDER.STATUS_ANY', defaultMessage: 'Any state', description: 'Order state: any state' },
    [OrderStatusName.PENDING]: { id: 'Objects.ORDER.STATUS_PENDING', defaultMessage: 'Pending', description: 'Order state: pending' },
    [OrderStatusName.PROCESSING]: { id: 'Objects.ORDER.STATUS_PROCESSING', defaultMessage: 'Processing', description: 'Order state: processing' },
    [OrderStatusName.COMPLETED]: { id: 'Objects.ORDER.STATUS_COMPLETED', defaultMessage: 'Completed', description: 'Order state: completed' },
    [OrderStatusName.CANCELLED]: { id: 'Objects.ORDER.STATUS_CANCELLED', defaultMessage: 'Cancelled', description: 'Order state: cancelled' }
};

export function useOrderStatusDisplayMap(): Map<string, string> {
    const intl = useIntl();
    return useMemo(
        () =>
            new Map<string, string>(
                (Object.keys(ORDER_STATUS_MESSAGE_IDS) as OrderStatusName[]).map((status) => [status, intl.formatMessage(ORDER_STATUS_MESSAGE_IDS[status])])
            ),
        [intl]
    );
}

export interface OrderStatusBadgeProps {
    status: OrderStatusName | string;
}

export const OrderStatusBadge = ({ status }: OrderStatusBadgeProps) => {
    const displayMap = useOrderStatusDisplayMap();
    const label = displayMap.get(status) ?? OrderStatus.format(status);

    return (
        <EntityStatusBadge
            label={label}
            variant={OrderStatus.getBadgeVariant(status)}
        />
    );
};
